import { edi } from '@/requests';
import { deleteRequest } from '@/core';

export default async function unscheduleSuborderOnTransporterOrderRequest(transporterOrderId, subOrderId) {
	let url = edi.unscheduleTransporterOrder(transporterOrderId, subOrderId);
	let response = await deleteRequest(url, {}, {});
	return response;
}